import { render, staticRenderFns } from "./VersionModalJoinTeam.vue?vue&type=template&id=0babc6d8&scoped=true"
import script from "./VersionModalJoinTeam.vue?vue&type=script&lang=js"
export * from "./VersionModalJoinTeam.vue?vue&type=script&lang=js"
import style0 from "./VersionModalJoinTeam.vue?vue&type=style&index=0&id=0babc6d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0babc6d8",
  null
  
)

export default component.exports